import { SERVICE } from './constants'

export const FETCH_VENDORS = `${SERVICE}/FETCH_VENDORS`
export const SET_FETCH_VENDORS_ERROR = `${SERVICE}/SET_FETCH_VENDORS_ERROR`
export const SET_VENDORS = `${SERVICE}/SET_VENDORS`
export const SET_PAGINATION = `${SERVICE}/SET_PAGINATION`
export const UPDATE_VENDOR = `${SERVICE}/UPDATE_VENDOR`

export const SET_SELECTED = `${SERVICE}/SET_SELECTED`
export const UPDATE_SELECTED = `${SERVICE}/UPDATE_SELECTED`
export const SELECT_VENDOR = `${SERVICE}/SELECT_VENDOR`
export const RESET_SELECTED = `${SERVICE}/RESET_SELECTED`
export const RESET_SELECTED_ON_PAGE = `${SERVICE}/RESET_SELECTED_ON_PAGE`
export const SELECT_ALL = `${SERVICE}/SELECT_ALL`

export const ADD_VENDOR = `${SERVICE}/ADD_VENDOR`
export const ADD_VENDOR_ERROR = `${SERVICE}/ADD_VENDOR_ERROR`
export const ADD_VENDOR_SUCCESS = `${SERVICE}/ADD_VENDOR_SUCCESS`
export const ADD_VENDOR_CONFIRM = `${SERVICE}/ADD_VENDOR_CONFIRM`
export const ADD_VENDOR_NOT_REGISTERED = `${SERVICE}/ADD_VENDOR_NOT_REGISTERED`
export const ADD_VENDOR_CLEAR = `${SERVICE}/ADD_VENDOR_CLEAR`
export const CONFIRM_ADD_VENDOR_FAKE = `${SERVICE}/CONFIRM_ADD_VENDOR_FAKE`

export const GET_SEARCH_OPTIONS = `${SERVICE}/GET_SEARCH_OPTIONS`
export const SET_SEARCH_OPTIONS = `${SERVICE}/SET_SEARCH_OPTIONS`
export const CLEAR_SEARCH_OPTIONS = `${SERVICE}/CLEAR_SEARCH_OPTIONS`

export const REMOVE = `${SERVICE}/REMOVE`
export const REMOVE_ERROR = `${SERVICE}/REMOVE_ERROR`
export const REMOVE_SUCCESS = `${SERVICE}/REMOVE_SUCCESS`
export const REMOVE_FAKE = `${SERVICE}/REMOVE_FAKE`

export const SET_SEARCH_FILTERS = `${SERVICE}/SET_SEARCH_FILTERS`
export const RESET_SEARCH_FILTERS = `${SERVICE}/RESET_SEARCH_FILTERS`
